<template>
  <div class="settings">
    <section class="hero is-primary">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            Settings
          </h1>
          <h2 class="subtitle">
            Edit the settings of any tracker, or add one
          </h2>
        </div>
      </div>
    </section>
    <div class="container">
      <div class="tile is-ancestor">
        <div class="tile is-vertical is-4 is-parent">
          <article class="tile is-child box has-background-info">
            <tile-tracker :white="true" />
          </article>
          <article class="tile is-child box has-background-dark">
            <tile-sleep :white="true" />
          </article>
        </div>
        <div class="tile is-8 is-parent">
          <article class="tile is-child box">
            <tile-user />
          </article>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import tileAddTracker from '@/components/tileAddTracker.vue'
import tileSleep from '@/components/tileSleep.vue'
import tileUser from '@/components/tileUser.vue'

export default {
  name: 'settings',
  components: {
    'tile-tracker': tileAddTracker,
    'tile-sleep': tileSleep,
    'tile-user': tileUser
  },
  async created () {
    if (!await this.$store.dispatch('checkAuthToken')) return this.$router.push('/login')
  }
}
</script>

<style scoped>
.hero {
  margin-bottom: 1em;
}
.tile.is-child {
  margin-left: 1.5rem !important;
  margin-right: 1.5rem !important;
}
</style>
